// extracted by mini-css-extract-plugin
module.exports = {"root":"root__15jhm"};